class Starfield {
  constructor(containerId) {
    this.container = document.getElementById(containerId);
    if (!this.container) return;
    
    this.canvas = document.createElement('canvas');
    this.ctx = this.canvas.getContext('2d');
    this.stars = [];
    this.animationId = null;
    this.mouseX = 0;
    this.mouseY = 0;
    
    this.init();
  }

  init() {
    this.container.appendChild(this.canvas);
    this.resize();
    this.createStars();
    this.animate();
    this.setupEventListeners();
  }

  resize() {
    const rect = this.container.getBoundingClientRect();
    this.canvas.width = rect.width;
    this.canvas.height = rect.height;
    this.width = rect.width;
    this.height = rect.height;
  }

  createStars() {
    const starCount = Math.floor((this.width * this.height) / 15000);
    this.stars = [];
    
    for (let i = 0; i < starCount; i++) {
      this.stars.push({
        x: Math.random() * this.width,
        y: Math.random() * this.height,
        radius: Math.random() * 1.5 + 0.5,
        opacity: Math.random() * 0.8 + 0.2,
        speed: Math.random() * 0.5 + 0.1,
        twinkle: Math.random() * Math.PI * 2
      });
    }
  }

  setupEventListeners() {
    window.addEventListener('resize', () => {
      this.resize();
      this.createStars();
    });

    if (this.container) {
      this.container.addEventListener('mousemove', (e) => {
        const rect = this.container.getBoundingClientRect();
        this.mouseX = e.clientX - rect.left;
        this.mouseY = e.clientY - rect.top;
      });
    }
  }

  animate() {
    this.ctx.clearRect(0, 0, this.width, this.height);
    
    const time = Date.now() * 0.001;
    
    this.stars.forEach((star, index) => {
      // Twinkling effect
      star.twinkle += 0.02;
      const twinkle = Math.sin(star.twinkle) * 0.3 + 0.7;
      const currentOpacity = star.opacity * twinkle;
      
      // Mouse interaction - stars move away from cursor
      let dx = star.x - this.mouseX;
      let dy = star.y - this.mouseY;
      const distance = Math.sqrt(dx * dx + dy * dy);
      const maxDistance = 200;
      
      if (distance < maxDistance) {
        const force = (maxDistance - distance) / maxDistance;
        const angle = Math.atan2(dy, dx);
        star.x += Math.cos(angle) * force * 2;
        star.y += Math.sin(angle) * force * 2;
        
        // Keep stars in bounds
        star.x = Math.max(0, Math.min(this.width, star.x));
        star.y = Math.max(0, Math.min(this.height, star.y));
      }
      
      // Draw star
      this.ctx.beginPath();
      this.ctx.arc(star.x, star.y, star.radius, 0, Math.PI * 2);
      this.ctx.fillStyle = `rgba(255, 255, 255, ${currentOpacity})`;
      this.ctx.fill();
      
      // Add glow effect for some stars
      if (star.radius > 1) {
        const gradient = this.ctx.createRadialGradient(
          star.x, star.y, 0,
          star.x, star.y, star.radius * 3
        );
        gradient.addColorStop(0, `rgba(255, 255, 255, ${currentOpacity})`);
        gradient.addColorStop(1, 'rgba(255, 255, 255, 0)');
        this.ctx.fillStyle = gradient;
        this.ctx.fill();
      }
    });
    
    this.animationId = requestAnimationFrame(() => this.animate());
  }

  destroy() {
    if (this.animationId) {
      cancelAnimationFrame(this.animationId);
    }
    if (this.canvas && this.canvas.parentNode) {
      this.canvas.parentNode.removeChild(this.canvas);
    }
  }
}

// Initialize starfield for all hero sections
document.addEventListener('DOMContentLoaded', () => {
  const starfieldContainers = document.querySelectorAll('[id^="starfield-"]');
  starfieldContainers.forEach(container => {
    new Starfield(container.id);
  });
});

// Reinitialize in theme editor
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const starfieldContainer = event.target.querySelector('[id^="starfield-"]');
    if (starfieldContainer) {
      new Starfield(starfieldContainer.id);
    }
  });
}

